import { render, staticRenderFns } from "./hotActivity.vue?vue&type=template&id=7237fc60&scoped=true"
import script from "./hotActivity.vue?vue&type=script&lang=js"
export * from "./hotActivity.vue?vue&type=script&lang=js"
import style0 from "./hotActivity.vue?vue&type=style&index=0&id=7237fc60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7237fc60",
  null
  
)

export default component.exports